export enum Direction {
  ASC = "asc",
  DESC = "desc"
}